import { ClipboardIcon } from "@heroicons/react/24/outline";
import React, { useCallback } from "react";
import { useClipboard } from "@chakra-ui/react";
import { IconButton } from "./icon-button";
import { useToast } from "./toast";
import { Tooltip } from "./tooltip";
export function ClipboardButton({ text, ...props }) {
    const { toast } = useToast();
    const { onCopy } = useClipboard(text);
    const copy = useCallback(() => {
        onCopy();
        toast({
            variant: "success",
            id: "copy-to-clipboard",
            title: "Copied to clipboard",
        });
    }, [onCopy, toast]);
    return (React.createElement(Tooltip, { message: "Copy to clipboard", ...props },
        React.createElement(IconButton, { "aria-label": "Copy to clipboard", icon: ClipboardIcon, onClick: copy })));
}
